import { and, count, menu_product, type PowerSyncDrizzleDB } from "@malla/powersync";
import { liveMenuProductFilters } from "./filters";

/**
 * Counts LIVE catalog products from local SQLite. Feeds `checkUnsyncedActor`
 * (the "keep local data?" prompt when migrating from guest to a real account):
 * previously it ran a crude `count() from(menu_product)` in
 * `auth/controllers.ts`, which also counted items in the trash (a scattered
 * invariant bug—a deleted product triggered the "you have local data" prompt).
 * Through the live layer it only counts live items (and excludes those in a
 * trashed category through the `liveMenuProductFilters` cohort)—consistent with
 * the rest of the views. (The guest→real merge still runs through
 * `sweepVisitorData`, so no row is lost; this counter only decides whether the
 * prompt is SHOWN.)
 */
export function getLiveMenuProductCountForUserQuery(db: PowerSyncDrizzleDB) {
  return db
    .select({ total: count() })
    .from(menu_product)
    .where(and(...liveMenuProductFilters()));
}
